import { call } from 'redux-saga/effects';

import { DatabasesWithCrass } from '~src/catalog/resources/DatabasesWithCrass';
import { Messages } from '~src/codegen/Localize';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { MixedContentItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { DatabaseContentType,DatabaseWithCRASSSearchSubspaceType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { getDatabases } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { getGenericDefaultFilters } from '../../../spacesPlatform/contentDefinitions/getDefaultFilters';
import { DatabaseCard } from '../databases/DatabaseCard';

const dbInProjectsEnabled: boolean =  FeatureFlags.databasesInProjectsEnabled
                                      && FeatureFlags.databasesInProjectsPostMVPEnabled;

export const DatabaseDefinition: MixedContentItemDefinition & SpaceDefinition<'database'> = {
  itemType: 'database',
  contentType: 'database',
  pluralName: Messages.databasesAndFiles,
  singularName: Messages.database,
  emptyStateMessage: Messages.databasesAndFilesEmptyMessage,
  siteFilterByTypeDropdownName: () => 'databases',
  contentFilterKeys: DatabaseWithCRASSSearchSubspaceType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: dbInProjectsEnabled ? DatabaseCard : GenericCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => {
    return DatabasesWithCrass.all().withExtraParams(DatabaseContentType.extraQueryParams);
  },
  getContentInfo: (contentList: IContentInfo[]) => call(getDatabases, contentList),
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.catalogDatabaseUrl(contentId),
  headerIconPath: () => '',
  supportedDisplayModes: dbInProjectsEnabled ? ['list', 'thumbnail'] : ['list'],
};
